import { numericRange } from '@app/functions/numeric-range';
import { ColumnFilter } from '@app/modules/table/classes/column-filters/column-filter.abstract';
import { ColumnFilterDisplay } from '@app/modules/table/types/column-filter-display.type';
import { Filter } from '../../filter.abstract';

export const isYearFilter = (filter: Filter): filter is YearFilter => filter.type === 'year';

export class YearFilter extends ColumnFilter {
    type: ColumnFilterDisplay = 'year';
    options: number[] = [];
    selectedYear: number;

    constructor(
        protected field: string,
        defaultSelectedYear?: number,
        label?: string
    ) {
        super();
        this.options = this.getYearsRangeOptions();

        this.label = label;

        if (defaultSelectedYear) {
            this.setYear(defaultSelectedYear);
        }

        this.isReady = true;
    }

    clear(): void {
        this.selectedYear = null;
        this.emitChanges();
    }

    hasValues(): boolean {
        return !!this.selectedYear;
    }

    setYear(year: number): void {
        this.selectedYear = year;
        this.emitChanges();
    }

    private emitChanges(): void {
        const from: string | null = this.selectedYear ? `${this.selectedYear}-01-01` : null;
        const to: string | null = this.selectedYear ? `${this.selectedYear}-12-31` : null;

        this.onChanges.next([
            { field: `${this.field}.from`, value: from },
            { field: `${this.field}.to`, value: to },
        ]);
    }

    private getYearsRangeOptions(): number[] {
        const pastYears = 10;
        const futureYears = 3;
        const startYear = new Date().getFullYear() - pastYears;

        return numericRange(pastYears + futureYears)
            .map((offset: number) => startYear + offset)
            .reverse();
    }
}
